import getConflictsString from './getConflictsString';
import { hasAttendees } from 'owa-calendar-event-capabilities';
import areAttendeeTypeCollectionsEqual from './areAttendeeTypeCollectionsEqual';
import getAttendeeResponseCounts from './getAttendeeResponseCounts';
import getAttendeeResponseString from './getAttendeeResponseString';
import { DisplayDate } from 'owa-datetime';
import AttendeeType from 'owa-service/lib/contract/AttendeeType';
import CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';

export default function getSchedulingItemSecondLineText(
    allAttendees: AttendeeType[],
    allAttendeesExceptOrganizer: AttendeeType[],
    start: DisplayDate,
    end: DisplayDate,
    isAllDayEvent: boolean,
    isNonDraftEventOriginalTime: boolean,
    organizerConflict: boolean,
    attendeeConflictCount: number,
    locationConflictCount: number,
    event: CalendarEvent,
    originalEvent: CalendarEvent
): string {
    const attendeesAreEqual = areAttendeeTypeCollectionsEqual(
        [...originalEvent.RequiredAttendees, ...originalEvent.OptionalAttendees],
        [...event.RequiredAttendees, ...event.OptionalAttendees]
    );
    const resourcesAreEqual = areAttendeeTypeCollectionsEqual(
        originalEvent.Resources,
        event.Resources
    );
    if (isNonDraftEventOriginalTime && attendeesAreEqual && resourcesAreEqual) {
        if (hasAttendees(event)) {
            return getAttendeeResponseString(getAttendeeResponseCounts(event));
        } else {
            return null;
        }
    }

    return getConflictsString(
        allAttendees,
        allAttendeesExceptOrganizer,
        start,
        end,
        isAllDayEvent,
        originalEvent,
        organizerConflict,
        attendeeConflictCount,
        locationConflictCount
    );
}
